import * as e from "react";
import { forwardRef as t } from "react";
const n = t(function(o, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...o
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M16.1094 4.10936V3H7.34377V4.10936H4V5.875C4 7.23439 4.64064 9.39064 7.7969 9.7656C8.51565 11.1406 10.0156 12.3437 11.6719 12.375H11.7656C13.4375 12.3437 14.9219 11.1406 15.6406 9.7656C18.8125 9.39064 19.4531 7.23439 19.4531 5.875V4.10936H16.1094ZM13.2032 15.9375V13.4687C13.2032 13.4687 12.3594 13.0625 11.7501 13.0313H11.6876C11.0782 13.0625 10.2344 13.4687 10.2344 13.4687V15.9375C10.2344 17.5937 7.71879 17.7188 7.71879 17.7188V19H15.7188V17.7188C15.7188 17.7188 13.2032 17.5937 13.2032 15.9375ZM5.17192 6.42188V5.20312H7.34381V8.01559C7.34381 8.18746 7.35939 8.34374 7.37504 8.5156C6.14064 7.98436 5.17192 7.59376 5.17192 6.42188ZM18.2656 6.42188C18.2656 7.59376 17.3125 7.98436 16.0781 8.5156C16.0938 8.34374 16.1094 8.18746 16.1094 8.01559V5.20312H18.2656V6.42188Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Trophy
};
